import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import { LOCALIZED_FLAGS, INVERTED_FLAGS } from '~/const/featureFlags';
export default (function (_ref, inject) {
  var app = _ref.app,
    store = _ref.store;
  inject('isUnleashFeatEnable', function (flag) {
    return store.getters['features/isEnabled'](flag);
  });
  inject('isEnabled', function (flag, localeIso) {
    var enabled = true;
    if (LOCALIZED_FLAGS[flag]) {
      if (!localeIso) return false;
      enabled = LOCALIZED_FLAGS[flag][localeIso];
    }
    return INVERTED_FLAGS.includes(flag) ? Boolean(!app.$cookies.get(flag)) && enabled : Boolean(app.$cookies.get(flag)) && enabled;
  });
});